export type OptionalConsent =
  | 'advices_and_offers_sustainability'
  | 'advices_and_offers_brand'
  | 'actionmail'
  | 'newsletter';

export type MandatoryConsent = 'thuisvoordeel' | 'zaakvoordeel' | 'goedzitters' | 'service_mailing';

export type Consent = OptionalConsent | MandatoryConsent;

export const OPTIONAL_CONSENTS: readonly OptionalConsent[] = [
  'advices_and_offers_sustainability',
  'advices_and_offers_brand',
  'actionmail',
  'newsletter',
] as const;

export const MANDATORY_CONSENTS: readonly MandatoryConsent[] = [
  'thuisvoordeel',
  'zaakvoordeel',
  'goedzitters',
  'service_mailing',
] as const;
